module.exports = __webpack_public_path__ + "img/LoadCurveScreenshot.5fe2b28c.png";